<template>
  <Tooltip
    :title="tooltip"
    side="bottom"
    class="!w-fit"
    disableHoverableContent
  >
    <Badge
      :label="
        label ||
        $t(
          isPrivate
            ? 'components.visibility.private'
            : 'components.visibility.public'
        )
      "
      type="color"
      :size="size"
      :icon="iconOnly ? 'only' : 'leading'"
      :as="as"
      :class="{
        'fg-disabled': isPrivate,
      }"
    >
      <Icon
        :name="isPrivate ? 'eye-hidden' : 'eye-visible'"
        :size="size"
        :class="{ '!fg-disabled': isPrivate }"
      />
    </Badge>
  </Tooltip>
</template>

<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { Badge, sizes } from "@/SharedComponents/Badges";
import { Icon } from "@/SharedComponents/Icon";
import { Tooltip } from "@/SharedComponents/Tooltips";

const { t } = useI18n();

const props = defineProps({
  isPrivate: { type: Boolean, required: true },
  iconOnly: { type: Boolean, required: false },
  size: {
    type: String,
    validator: (val) => sizes.includes(val),
    default: "sm",
  },
  // optional label to override the default visibility label
  label: { type: String, required: false },
  as: { type: String, default: "div" },
});

const tooltip = computed(() => {
  if (props.iconOnly) {
    return props.isPrivate
      ? t("components.tooltips.private")
      : t("components.tooltips.public");
  }

  return t("components.tooltips.visibility");
});
</script>
